<div class="feedback-inner cnt-row-centered">
    <div class="filler"></div>
    <simple-btn [width]="30"
            [height]="30"
            [cornerRadius]="20"
            [horizontalPadding]="0"
            [leftSpace]="0"
            [rightSpace]="0"
            [borderWidth]="2"
            [rightImgCls]="'btn-close'"
            [rightImgHoverCls]="'btn-close-hover'"
            [text]="''"
            [hoverFillCls]="'g4Background'"
            [textColorCls]="'g4Color'"
            [borderColorCls]="'g4Border'"
            [hoverBorderColorCls]="'g4Border'"
            [backgroundFillCls]="'g2Background'"
            (click)="onClose()"
            data-testid="feedbackPopupCloseButton">
    </simple-btn>
</div>

<div class="cnt-row-centered">
    <div class="filler"></div>
    <div class="b1Color h1Font" i18n>
        {{ 'WE_NEED_YOUR_FEEDBACK' | translate }}!
    </div>
    <div class="filler"></div>
</div>

<div [height]="12"></div>

<div class="cnt-row-centered">
    <div class="filler"></div>
    <div class="g4Background feedback-line"></div>
    <div class="filler"></div>
</div>

<div [height]="12"></div>

<div class="cnt-row-centered">
    <div class="filler"></div>
    <div class="b1Color h3Font" i18n>
        {{ 'IS_THERE_ANYTHING_STOPPING_YOU_FROM_UPGRADING' | translate }}?
    </div>
    <div class="filler"></div>
</div>

<div [height]="20"></div>

<div class="cnt-row-centered feedback-radio">
    <radiogroup [(ngModel)]="feedbackChoice"
                [items]="radioItems"
                [orientationVertical]="true"
                [itemSpace]="10"
                (change)="handleChoiceRadioChange($event)">
    </radiogroup>
</div>

<div [height]="20"></div>

<div [ngClass]="{'hiddenCls': !feedbackChoice}" class="cnt-row-centered">
    <div class="filler"></div>
    <textarea #commentArea
              [(ngModel)]="feedbackComment"
              i18n-placeholder
              [placeholder]="'TELL_US_HOW_WE_COULD_IMPROVE_IN_A_FEW_SENTENCES' | translate"
              class="feedback-comment p1Font b1Color"
              data-testid="feedbackComment"></textarea>
    <div class="filler"></div>
</div>

<div [height]="10"></div>

<div [ngClass]="{'hiddenCls': !feedbackChoice}" class="feedback-anonymous">
    <check [label]="'KEEP_MY_FEEDBACK_ANONYMOUS' | translate"
           [(ngModel)]="feedbackAnonymous"
           [testId]="'feedbackAnonymousCheck'">
    </check>
</div>

<div [height]="20"></div>

<div class="cnt-row-centered">
    <div class="filler"></div>
    <simple-btn [horizontalPadding]="32"       
             [width]="350"         
             [disabled]="!feedbackChoice"
             [text]="'SUBMIT_FEEDBACK' | translate"
             [backgroundFillCls]="'o2Background'"
             [hoverFillCls]="'o1Background'"
             [boxShadowCls]="'primary-shadow'"
             [textCls]="'large-btn-text'"
             [height]="40"
             [cornerRadius]="50"
             data-testid="submitFeedbackButton"
             (click)="handleSubmitClick()">
    </simple-btn>
    <div class="filler"></div>
</div>
